module.exports = __webpack_public_path__ + "img/1.3ddb1bf1.jpg";